module.exports = __webpack_public_path__ + "img/logo2.3a40d626.jpg";